import OpenSeaDragon from "openseadragon";
import React, { useEffect, useState } from "react";

const OpenSeaDragonViewer = ({ image, homeTooltip, zoomInTooltip, zoomOutTooltip, fullPageTooltip }) => {
  const [viewer, setViewer] = useState(null);

  useEffect(() => {
    if (image && viewer) {
      viewer.open(image.tileSource);
    }
  }, [image]);

  const InitOpenseadragon = () => {
    viewer && viewer.destroy();
    OpenSeaDragon.setString("Tooltips.Home",homeTooltip);
    OpenSeaDragon.setString("Tooltips.ZoomOut",zoomOutTooltip);
    OpenSeaDragon.setString("Tooltips.ZoomIn",zoomInTooltip);
    OpenSeaDragon.setString("Tooltips.FullPage",fullPageTooltip);

    let newViewer = OpenSeaDragon({
        id: "openSeaDragon",
        prefixUrl: "/assets/images/",
        animationTime: 0.5,
        blendTime: 0.1,
        constrainDuringPan: true,
        maxZoomPixelRatio: 2,
        minZoomLevel: 0,
        visibilityRatio: 1,
        // zoomPerScroll: 2,
        tileSources: image.tileSource
      })

    setViewer( newViewer );

  };

  useEffect(() => {
    InitOpenseadragon();
    return () => {
        viewer && viewer.destroy();
    };
  }, []);

  const ariaLabel = image.alt_text ? {"aria-label": image.alt_text } : {}

  return (
    <div id="openSeaDragon" {...ariaLabel} onContextMenu={ e => e.preventDefault() } style={{height: "480px", width: "auto"}}></div>
  );
};

export { OpenSeaDragonViewer };